import { type UseQueryOptions, useQuery } from '@tanstack/vue-query'
import type { FetchSwapSuccessResponse } from '../../types/api/response/swap'
import type { FetchSwapPayload } from '../../types/api/payload/swap'
import { axiosInstance } from '@/modules/Core/plugins/axios'

export const QUERY_KEY = 'swap'
const ENDPOINT = '/Swap/:id'

export async function fetchSwap({ id }: FetchSwapPayload) {
  const data = await axiosInstance.get<FetchSwapSuccessResponse>(
    ENDPOINT.replace(':id', id.value),
    {
      baseURL: 'https://api-offer.dev.journeymentor.net/api/v1',
    }
  )
  return data.data
}

export function useFetchSwap(
  payload: FetchSwapPayload,
  options?: UseQueryOptions<Awaited<ReturnType<typeof fetchSwap>>>
) {
  return useQuery({
    queryFn: () => fetchSwap(payload),
    queryKey: [QUERY_KEY, payload.id],
    ...options,
  })
}
